import React from "react";

const Plate = ()=>{
  return(
    <div>
    hello
    </div>
  )
}
export default Plate;
